import { Icon } from 'app/components/Icon';
import styles from './Legend.module.scss';
interface LegendItemI {
  color?: string;
  description?: string;
  opacity?: string;
  iconToShow: 'all' | 'none' | 'satellite' | 'terrestrial' | 'port' | 'portTerminal' | 'aton' | 'motionless-target';
}
export const LegendItem = ({ color, description, opacity, iconToShow }: LegendItemI) => {
  return (
    <>
      {iconToShow === 'all' && (
        <div className={styles.item}>
          <Icon name="satellite-target" color={color} size="16px" fillOpacity={opacity} />
          <Icon name="terrestrial-target" color={color} size="16px" fillOpacity={opacity} />– {description}
        </div>
      )}
      {iconToShow === 'satellite' && (
        <div className={styles.item}>
          <Icon name="satellite-target" color={color} size="16px" />– {description}
        </div>
      )}
      {iconToShow === 'terrestrial' && (
        <div className={styles.item}>
          <Icon name="terrestrial-target" color={color} size="16px" />– {description}
        </div>
      )}
      {iconToShow === 'port' && (
        <div className={styles.item}>
          <Icon name={'port'} size={'16px'} />– {description}
        </div>
      )}
      {iconToShow === 'portTerminal' && (
        <div className={styles.item}>
          <Icon name={'terminal'} size={'16px'} />– {description}
        </div>
      )}
      {iconToShow === 'aton' && (
        <div className={styles.item}>
          <Icon name={'aton'} size={'16px'} />– {description}
        </div>
      )}
      {iconToShow === 'motionless-target' && (
        <div className={styles.item}>
          <Icon name={'motionless-target'} color={'#fff'} size={'16px'} />– {description}
        </div>
      )}
    </>
  );
};
